import BaseForm from '../base';
import { LatLongColumnsComponent } from '../components';
export class RoutersForm extends BaseForm {
    constructor(...args) {
        super(...args);
        this.components = [
            new LatLongColumnsComponent(),
            {
                label: 'Timezone',
                key: 'timezone',
                type: 'select-timezone',
            },
            {
                label: 'ICCID',
                key: 'iccid',
                type: 'textfield',
                validate: {
                    required: true
                }
            },
            {
                label: 'IP',
                key: 'ip',
                type: 'textfield',
            },
            {
                label: 'Port',
                key: 'port',
                type: 'number',
            },
            {
                label: 'Make',
                key: 'make',
                type: 'textfield',
            },
            {
                label: 'Model',
                key: 'model',
                type: 'textfield',
            },
            {
                label: 'Carrier',
                key: 'carrier',
                type: 'textfield',
            },
        ];
    }
}
